/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from '../components/Footer';

function Addaccount() {
    const navigate = useNavigate();
    const location = useLocation();
    
    // Check if we're editing an account
    const isEditMode = location.state?.isEdit || false;
    const accountToEdit = location.state?.account || null;
    
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [users, setUsers] = useState([]);
    const [filteredBillingStates, setFilteredBillingStates] = useState([]);
    const [filteredBillingCities, setFilteredBillingCities] = useState([]);
    const [filteredShippingStates, setFilteredShippingStates] = useState([]);
    const [filteredShippingCities, setFilteredShippingCities] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sameAsBilling, setSameAsBilling] = useState(false);
    
    const [newRecord, setNewRecord] = useState({
        company_name: "",
        website: "",
        industry: "",
        sub_industry: "",
        account_status: "",
        phone: "",
        email: "",
        notes: "",
        billing_address_line1: "",
        billing_address_line2: "",
        billing_country_id: "",
        billing_state_id: "",
        billing_city_id: "",
        billing_zip: "",
        shipping_address_line1: "",
        shipping_address_line2: "",
        shipping_country_id: "",
        shipping_state_id: "",
        shipping_city_id: "",
        shipping_zip: "",
        isactive: true,
    });

    // Populate form with account data if editing
    useEffect(() => {
        if (isEditMode && accountToEdit) {
            console.log("Edit account data: ", accountToEdit);
            setNewRecord({
                company_name: accountToEdit.company_name || "",
                website: accountToEdit.website || "",
                industry: accountToEdit.industry || "",
                sub_industry: accountToEdit.sub_industry || "",
                account_status: accountToEdit.account_status || "",
                phone: accountToEdit.phone || "",
                email: accountToEdit.email || "",
                notes: accountToEdit.notes || "",
                billing_address_line1: accountToEdit.billing_address_line1 || "",
                billing_address_line2: accountToEdit.billing_address_line2 || "",
                billing_country_id: accountToEdit.billing_country_id || "",
                billing_state_id: accountToEdit.billing_state_id || "",
                billing_city_id: accountToEdit.billing_city_id || "",
                billing_zip: accountToEdit.billing_zip || "",
                shipping_address_line1: accountToEdit.shipping_address_line1 || "",
                shipping_address_line2: accountToEdit.shipping_address_line2 || "",
                shipping_country_id: accountToEdit.shipping_country_id || "",
                shipping_state_id: accountToEdit.shipping_state_id || "",
                shipping_city_id: accountToEdit.shipping_city_id || "",
                shipping_zip: accountToEdit.shipping_zip || "",
                isactive: accountToEdit.isactive !== undefined ? accountToEdit.isactive : true,
            });
        }
    }, [isEditMode, accountToEdit]);

    const [errors, setErrors] = useState({
        company_name: "",
        phone: "",
        email: "",
        industry: "",
        sub_industry: "",
        account_status: "",
        billing_address_line1: "",
        billing_country_id: "",
        billing_state_id: "",
        billing_city_id: "",
    });

    const validateForm = () => {
        let formErrors = {};
        const phoneRegex = /^\d{10}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!newRecord.company_name) {
            formErrors.company_name = "Company Name is required";
        }

        if (!newRecord.phone) {
            formErrors.phone = "Phone is required";
        } else if (!phoneRegex.test(newRecord.phone)) {
            formErrors.phone = 'Please enter a valid 10-digit phone number';
        }

        if (newRecord.email && !emailRegex.test(newRecord.email)) {
            formErrors.email = 'Please enter a valid email address';
        }

        if (!newRecord.industry) {
            formErrors.industry = "Industry is required";
        }

        if (!newRecord.sub_industry) {
            formErrors.sub_industry = "Sub Industry is required";
        }

        if (!newRecord.account_status) {
            formErrors.account_status = "Account Status is required";
        }

        if (!newRecord.billing_address_line1) {
            formErrors.billing_address_line1 = "Billing Address Line 1 is required";
        }

        if (!newRecord.billing_country_id) {
            formErrors.billing_country_id = "Billing Country is required";
        }

        if (!newRecord.billing_state_id) {
            formErrors.billing_state_id = "Billing State is required";
        }

        if (!newRecord.billing_city_id) {
            formErrors.billing_city_id = "Billing City is required";
        }

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return false;
        }

        return true;
    };

    const select2InitRef = useRef(false);

    // Initialize Select2 when data is loaded
    useEffect(() => {
        if (countries.length > 0 && states.length > 0) {
            setTimeout(() => {
                try {
                    // Check if jQuery and Select2 are available
                    if (typeof $ !== 'undefined' && $.fn.select2) {
                        // Destroy existing Select2 instances first
                        $(".select2").each(function () {
                            if ($(this).hasClass('select2-hidden-accessible')) {
                                $(this).select2('destroy');
                            }
                        });

                        // Initialize Select2 for all select elements
                        $(".select2").select2({
                            width: '100%',
                            placeholder: function() {
                                return $(this).find('option:first').text();
                            }
                        });

                        // Handle Select2 change events
                        $('.select2').off('select2:select').on('select2:select', function (e) {
                            const selectElement = e.target;
                            const event = new Event('change', { bubbles: true });
                            selectElement.dispatchEvent(event);
                        });

                        console.log("Select2 initialized successfully");
                        select2InitRef.current = true;
                    } else {
                        console.warn("jQuery or Select2 not available");
                    }
                } catch (error) {
                    console.error("Error initializing Select2:", error);
                }
            }, 500);
        }

        return () => {
            try {
                if (typeof $ !== 'undefined' && $.fn.select2) {
                    $('.select2').off('select2:select');
                    $(".select2").each(function () {
                        if ($(this).hasClass('select2-hidden-accessible')) {
                            $(this).select2('destroy');
                        }
                    });
                }
            } catch (error) {
                console.error("Error cleaning up Select2:", error);
            }
        };
    }, [countries, states]);

    // Filter billing states based on selected billing country
    useEffect(() => {
        if (newRecord.billing_country_id && states.length > 0) {
            const filtered = states.filter(state => state.country_id == newRecord.billing_country_id);
            setFilteredBillingStates(filtered);

            if (!isEditMode || !accountToEdit) {
                if (newRecord.billing_state_id) {
                    const isStateValid = filtered.some(state => state.id == newRecord.billing_state_id);
                    if (!isStateValid) {
                        setNewRecord(prev => ({ ...prev, billing_state_id: "", billing_city_id: "" }));
                        setFilteredBillingCities([]);
                    }
                }
            }
        } else {
            setFilteredBillingStates([]);
            if (!isEditMode || !accountToEdit) {
                setFilteredBillingCities([]);
                setNewRecord(prev => ({ ...prev, billing_state_id: "", billing_city_id: "" }));
            }
        }
    }, [newRecord.billing_country_id, states, isEditMode, accountToEdit]);

    // Filter billing cities based on selected billing state
    useEffect(() => {
        if (newRecord.billing_state_id && cities.length > 0) {
            const filtered = cities.filter(city => city.state_id == newRecord.billing_state_id);
            setFilteredBillingCities(filtered);

            if (!isEditMode || !accountToEdit) {
                if (newRecord.billing_city_id) {
                    const isCityValid = filtered.some(city => city.id == newRecord.billing_city_id);
                    if (!isCityValid) {
                        setNewRecord(prev => ({ ...prev, billing_city_id: "" }));
                    }
                }
            }
        } else {
            setFilteredBillingCities([]);
            if (!isEditMode || !accountToEdit) {
                setNewRecord(prev => ({ ...prev, billing_city_id: "" }));
            }
        }
    }, [newRecord.billing_state_id, cities, isEditMode, accountToEdit]);

    // Filter shipping states based on selected shipping country
    useEffect(() => {
        if (newRecord.shipping_country_id && states.length > 0) {
            const filtered = states.filter(state => state.country_id == newRecord.shipping_country_id);
            setFilteredShippingStates(filtered);

            if (!isEditMode || !accountToEdit) {
                if (newRecord.shipping_state_id) {
                    const isStateValid = filtered.some(state => state.id == newRecord.shipping_state_id);
                    if (!isStateValid) {
                        setNewRecord(prev => ({ ...prev, shipping_state_id: "", shipping_city_id: "" }));
                        setFilteredShippingCities([]);
                    }
                }
            }
        } else {
            setFilteredShippingStates([]);
            if (!isEditMode || !accountToEdit) {
                setFilteredShippingCities([]);
                setNewRecord(prev => ({ ...prev, shipping_state_id: "", shipping_city_id: "" }));
            }
        }
    }, [newRecord.shipping_country_id, states, isEditMode, accountToEdit]);

    // Filter shipping cities based on selected shipping state
    useEffect(() => {
        if (newRecord.shipping_state_id && cities.length > 0) {
            const filtered = cities.filter(city => city.state_id == newRecord.shipping_state_id);
            setFilteredShippingCities(filtered);

            if (!isEditMode || !accountToEdit) {
                if (newRecord.shipping_city_id) {
                    const isCityValid = filtered.some(city => city.id == newRecord.shipping_city_id);
                    if (!isCityValid) {
                        setNewRecord(prev => ({ ...prev, shipping_city_id: "" }));
                    }
                }
            }
        } else {
            setFilteredShippingCities([]);
            if (!isEditMode || !accountToEdit) {
                setNewRecord(prev => ({ ...prev, shipping_city_id: "" }));
            }
        }
    }, [newRecord.shipping_state_id, cities, isEditMode, accountToEdit]);

    // Initialize filtered data when editing
    useEffect(() => {
        if (isEditMode && accountToEdit && states.length > 0 && cities.length > 0) {
            // Filter billing states and cities
            if (newRecord.billing_country_id) {
                const billingStates = states.filter(state => state.country_id == newRecord.billing_country_id);
                setFilteredBillingStates(billingStates);

                if (newRecord.billing_state_id) {
                    const billingCities = cities.filter(city => city.state_id == newRecord.billing_state_id);
                    setFilteredBillingCities(billingCities);
                }
            }

            // Filter shipping states and cities
            if (newRecord.shipping_country_id) {
                const shippingStates = states.filter(state => state.country_id == newRecord.shipping_country_id);
                setFilteredShippingStates(shippingStates);

                if (newRecord.shipping_state_id) {
                    const shippingCities = cities.filter(city => city.state_id == newRecord.shipping_state_id);
                    setFilteredShippingCities(shippingCities);
                }
            }
        }
    }, [isEditMode, accountToEdit, states, cities, newRecord.billing_country_id, newRecord.billing_state_id, newRecord.shipping_country_id, newRecord.shipping_state_id]);

    // Copy billing address to shipping address
    const handleSameAsBilling = (checked) => {
        setSameAsBilling(checked);
        if (checked) {
            setNewRecord(prev => ({
                ...prev,
                shipping_address_line1: prev.billing_address_line1,
                shipping_address_line2: prev.billing_address_line2,
                shipping_country_id: prev.billing_country_id,
                shipping_state_id: prev.billing_state_id,
                shipping_city_id: prev.billing_city_id,
                shipping_zip: prev.billing_zip,
            }));
        }
    };

    // Auto-copy billing to shipping when "same as billing" is checked
    useEffect(() => {
        if (sameAsBilling) {
            setNewRecord(prev => ({
                ...prev,
                shipping_address_line1: prev.billing_address_line1,
                shipping_address_line2: prev.billing_address_line2,
                shipping_country_id: prev.billing_country_id,
                shipping_state_id: prev.billing_state_id,
                shipping_city_id: prev.billing_city_id,
                shipping_zip: prev.billing_zip,
            }));
        }
    }, [sameAsBilling, newRecord.billing_address_line1, newRecord.billing_address_line2, 
        newRecord.billing_country_id, newRecord.billing_state_id, newRecord.billing_city_id, newRecord.billing_zip]);

    // Fetch Cities
    const fetchCities = async () => {
        try {
            const response = await axiosInstance.get("/cities/all");
            setCities(response.data.data);
            console.log("Cities", response.data.data);
        } catch (error) {
            console.error("Error fetching Cities:", error);
        }
    };

    // Fetch States
    const fetchStates = async () => {
        try {
            const response = await axiosInstance.get("/state/withcountry");
            setStates(response.data.data);
            console.log("States", response.data.data);
        } catch (error) {
            console.error("Error fetching States:", error);
        }
    };

    // Fetch Countries
    const fetchCountries = async () => {
        try {
            const response = await axiosInstance.get("/country/");
            setCountries(response.data.data);
            console.log("Countries", response.data.data);
        } catch (error) {
            console.error("Error fetching Countries:", error);
        }
    };

    // Fetch all data on component mount
    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                await Promise.all([
                    fetchCities(),
                    fetchStates(),
                    fetchCountries()
                ]);
            } catch (error) {
                console.error("Error loading data:", error);
            } finally {
                setLoading(false);
            }
        };
        
        loadData();
    }, []);

    // Handle Form Input Change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setNewRecord({ ...newRecord, [name]: newValue });
        
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: "" }));
        }
    };

    const saveAccount = async (event) => {
        event.preventDefault();

        if (isSaving || isSaved) return;

        if (validateForm()) {
            setIsSaving(true);
            setLoading(true);
            setErrors({});

            try {
                const created_by = localStorage.getItem('user_id');

                const updatedFormData = {
                    ...newRecord,
                    created_by: created_by,
                };
                
                console.log("Account data to save:", updatedFormData);

                let formResponse;
                if (isEditMode && accountToEdit) {
                    // Update existing account
                    formResponse = await axiosInstance.put(`/accounts/${accountToEdit.id}`, updatedFormData);
                    console.log("Account updated:", formResponse.data);
                    Swal.fire('Updated!', 'Account updated successfully', 'success');
                } else {
                    // Create new account
                    formResponse = await axiosInstance.post('/accounts/', updatedFormData);
                    console.log("Account created:", formResponse.data);
                    Swal.fire('Saved!', 'Account saved successfully', 'success');
                }

                setIsSaved(true);
                navigate("/account", { replace: true });

            } catch (error) {
                console.error('Error saving account:', error);
                let errorMessage = isEditMode ? 'There was an issue in updating the account.' : 'There was an issue in saving the account.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }

                Swal.fire({
                    icon: 'error',
                    title: isEditMode ? 'Error Updating Account!' : 'Error Saving Account!',
                    text: errorMessage,
                });
            } finally {
                setLoading(false);
                setIsSaving(false);
            }
        }
    };

    return (
        <div>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="card mb-0">
                        <div className="card-body">
                            <div className="page-header">
                                <div className="content-page-header">
                                    <h5>{isEditMode ? 'Edit Account' : 'Add Account'}</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <form onSubmit={saveAccount}>
                                        {/* Basic Details */}
                                        <div className="form-group-item">
                                            <h5 className="form-title">Basic Details</h5>
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Company Name <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="company_name" 
                                                            value={newRecord.company_name} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Company Name" 
                                                        />
                                                        {errors.company_name && <small className="text-danger">{errors.company_name}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Website</label>
                                                        <input 
                                                            type="text" 
                                                            name="website" 
                                                            value={newRecord.website} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Website URL" 
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Phone Number <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="phone" 
                                                            value={newRecord.phone} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Phone Number" 
                                                        />
                                                        {errors.phone && <small className="text-danger">{errors.phone}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Email</label>
                                                        <input 
                                                            type="email" 
                                                            name="email" 
                                                            value={newRecord.email} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Email Address" 
                                                        />
                                                        {errors.email && <small className="text-danger">{errors.email}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Industry <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="industry"
                                                            value={newRecord.industry}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Industry</option>
                                                            <option value="Accounting">Accounting</option>
                                                            <option value="Advertising / Marketing">Advertising / Marketing</option>
                                                            <option value="Aerospace / Aviation">Aerospace / Aviation</option>
                                                            <option value="Agriculture">Agriculture</option>
                                                            <option value="Apparel / Fashion">Apparel / Fashion</option>
                                                            <option value="Automotive">Automotive</option>
                                                            <option value="Banking / Financial Services">Banking / Financial Services</option>
                                                            <option value="Biotechnology">Biotechnology</option>
                                                            <option value="Chemicals">Chemicals</option>
                                                            <option value="Construction">Construction</option>
                                                            <option value="Consulting">Consulting</option>
                                                            <option value="Consumer Goods">Consumer Goods</option>
                                                            <option value="Defense & Security">Defense & Security</option>
                                                            <option value="Education">Education</option>
                                                            <option value="Electronics">Electronics</option>
                                                            <option value="Energy / Utilities / Oil & Gas">Energy / Utilities / Oil & Gas</option>
                                                            <option value="Engineering">Engineering</option>
                                                            <option value="Entertainment / Media">Entertainment / Media</option>
                                                            <option value="Environmental Services">Environmental Services</option>
                                                            <option value="Food & Beverages">Food & Beverages</option>
                                                            <option value="Government / Public Sector">Government / Public Sector</option>
                                                            <option value="Healthcare / Medical / Pharmaceuticals">Healthcare / Medical / Pharmaceuticals</option>
                                                            <option value="Hospitality / Travel / Tourism">Hospitality / Travel / Tourism</option>
                                                            <option value="Information Technology / Software">Information Technology / Software</option>
                                                            <option value="Insurance">Insurance</option>
                                                            <option value="Legal / Law">Legal / Law</option>
                                                            <option value="Logistics / Supply Chain">Logistics / Supply Chain</option>
                                                            <option value="Manufacturing">Manufacturing</option>
                                                            <option value="Marine / Shipping">Marine / Shipping</option>
                                                            <option value="Mining & Metals">Mining & Metals</option>
                                                            <option value="Non-Profit / NGO">Non-Profit / NGO</option>
                                                            <option value="Printing / Publishing">Printing / Publishing</option>
                                                            <option value="Real Estate">Real Estate</option>
                                                            <option value="Retail / E-commerce">Retail / E-commerce</option>
                                                            <option value="Telecommunications">Telecommunications</option>
                                                            <option value="Textiles">Textiles</option>
                                                            <option value="Transportation">Transportation</option>
                                                            <option value="Venture Capital / Private Equity">Venture Capital / Private Equity</option>
                                                            <option value="Warehousing / Distribution">Warehousing / Distribution</option>
                                                        </select>
                                                        {errors.industry && <small className="text-danger">{errors.industry}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Sub Industry <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="sub_industry" 
                                                            value={newRecord.sub_industry} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Sub Industry" 
                                                        />
                                                        {errors.sub_industry && <small className="text-danger">{errors.sub_industry}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Account Status <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="account_status"
                                                            value={newRecord.account_status}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Account Status</option>
                                                            <option value="Prospect">Prospect</option>
                                                            <option value="Customer">Customer</option>
                                                        </select>
                                                        {errors.account_status && <small className="text-danger">{errors.account_status}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Notes</label>
                                                        <textarea 
                                                            name="notes" 
                                                            value={newRecord.notes} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Notes"
                                                            rows="3"
                                                        />                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Billing Address */}
                                        <div className="form-group-item">
                                            <h5 className="form-title">Billing Address</h5>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Address Line 1 <span className="text-danger">*</span></label>
                                                        <input 
                                                            type="text" 
                                                            name="billing_address_line1" 
                                                            value={newRecord.billing_address_line1} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Billing Address Line 1" 
                                                        />
                                                        {errors.billing_address_line1 && <small className="text-danger">{errors.billing_address_line1}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Address Line 2</label>
                                                        <input 
                                                            type="text" 
                                                            name="billing_address_line2" 
                                                            value={newRecord.billing_address_line2} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Billing Address Line 2" 
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Country <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="billing_country_id"
                                                            value={newRecord.billing_country_id}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Country</option>
                                                            {countries.map((country) => (
                                                                <option key={country.id} value={country.id}>
                                                                    {country.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.billing_country_id && <small className="text-danger">{errors.billing_country_id}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>State <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="billing_state_id"
                                                            value={newRecord.billing_state_id}
                                                            onChange={handleChange}
                                                            disabled={!newRecord.billing_country_id}
                                                        >
                                                            <option value="">Select State</option>
                                                            {filteredBillingStates.map((state) => (
                                                                <option key={state.id} value={state.id}>
                                                                    {state.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.billing_state_id && <small className="text-danger">{errors.billing_state_id}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>City <span className="text-danger">*</span></label>
                                                        <select
                                                            className="select2"
                                                            name="billing_city_id"
                                                            value={newRecord.billing_city_id}
                                                            onChange={handleChange}
                                                            disabled={!newRecord.billing_state_id}
                                                        >
                                                            <option value="">Select City</option>
                                                            {filteredBillingCities.map((city) => (
                                                                <option key={city.id} value={city.id}>
                                                                    {city.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.billing_city_id && <small className="text-danger">{errors.billing_city_id}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>ZIP Code</label>
                                                        <input 
                                                            type="text" 
                                                            name="billing_zip" 
                                                            value={newRecord.billing_zip} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter ZIP Code" 
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Shipping Address */}
                                        <div className="form-group-item">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5 className="form-title mb-0">Shipping Address</h5>
                                                <div className="form-check">
                                                    <input 
                                                        className="form-check-input" 
                                                        type="checkbox" 
                                                        id="sameAsBilling"
                                                        checked={sameAsBilling}
                                                        onChange={(e) => handleSameAsBilling(e.target.checked)}
                                                    />
                                                    <label className="form-check-label" htmlFor="sameAsBilling">
                                                        Same as Billing Address
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Address Line 1</label>
                                                        <input 
                                                            type="text" 
                                                            name="shipping_address_line1" 
                                                            value={newRecord.shipping_address_line1} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Shipping Address Line 1"
                                                            disabled={sameAsBilling}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Address Line 2</label>
                                                        <input 
                                                            type="text" 
                                                            name="shipping_address_line2" 
                                                            value={newRecord.shipping_address_line2} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter Shipping Address Line 2"
                                                            disabled={sameAsBilling}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Country</label>
                                                        <select
                                                            className="select2"
                                                            name="shipping_country_id"
                                                            value={newRecord.shipping_country_id}
                                                            onChange={handleChange}
                                                            disabled={sameAsBilling}
                                                        >
                                                            <option value="">Select Country</option>
                                                            {countries.map((country) => (
                                                                <option key={country.id} value={country.id}>
                                                                    {country.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>State</label>
                                                        <select
                                                            className="select2"
                                                            name="shipping_state_id"
                                                            value={newRecord.shipping_state_id}
                                                            onChange={handleChange}
                                                            disabled={sameAsBilling || !newRecord.shipping_country_id}
                                                        >
                                                            <option value="">Select State</option>
                                                            {filteredShippingStates.map((state) => (
                                                                <option key={state.id} value={state.id}>
                                                                    {state.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>City</label>
                                                        <select
                                                            className="select2"
                                                            name="shipping_city_id"
                                                            value={newRecord.shipping_city_id}
                                                            onChange={handleChange}
                                                            disabled={sameAsBilling || !newRecord.shipping_state_id}
                                                        >
                                                            <option value="">Select City</option>
                                                            {filteredShippingCities.map((city) => (
                                                                <option key={city.id} value={city.id}>
                                                                    {city.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>ZIP Code</label>
                                                        <input 
                                                            type="text" 
                                                            name="shipping_zip" 
                                                            value={newRecord.shipping_zip} 
                                                            onChange={handleChange} 
                                                            className="form-control" 
                                                            placeholder="Enter ZIP Code"
                                                            disabled={sameAsBilling}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Status */}
                                        <div className="form-group-item">
                                            <h5 className="form-title">Status</h5>
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="input-block mb-3">
                                                        <label>Account Status</label>
                                                        <div className="form-check form-switch">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                name="isactive"
                                                                checked={newRecord.isactive}
                                                                onChange={handleChange}
                                                                id="accountStatus"
                                                            />
                                                            <label className="form-check-label" htmlFor="accountStatus">
                                                                {newRecord.isactive ? 'Active' : 'Inactive'}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="add-customer-btns text-end">
                                            <a href="/account" className="btn customer-btn-cancel">Cancel</a>
                                            <button 
                                                type="submit" 
                                                className="btn customer-btn-save" 
                                                disabled={isSaving || isSaved}
                                            >
                                                {isSaved ? (isEditMode ? 'Account Updated' : 'Account Saved') : 
                                                 isSaving ? (isEditMode ? 'Updating...' : 'Saving...') : 
                                                 (isEditMode ? 'Update Account' : 'Save Account')}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Addaccount;